import { ParentState, PassengerInformationState } from "@capone/checkout";
import {
  CART_UPDATE_TEXT,
  LOADING_GENERIC,
  LOADING_TRAVELERS,
} from "./textConstants";
import { CallState } from "redmond";

export const getLoadingMessage = (
  parentState: ParentState,
  corpPassengerCallState: CallState,
  isCorporate: boolean,
  childState?: string,
) => {
  switch (true) {
    case parentState === ParentState.passengerInformation &&
      (childState === PassengerInformationState.loading ||
        (isCorporate && corpPassengerCallState === CallState.InProcess)):
      return LOADING_TRAVELERS;
    case parentState === ParentState.loading:
      return LOADING_GENERIC;
    case parentState === ParentState.cartUpdate:
    case parentState === ParentState.cartUpdateForSeats:
      return CART_UPDATE_TEXT;
    default:
      return undefined;
  }
};
